import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui';
import { applyUpdate, dismissUpdate, useOfflineShell } from '../offlineShell';
import styles from './UpdateBanner.module.css';

/**
 * “A new version is ready” (docs/08, docs/15). Updating is always the person's choice;
 * open work is saved first, and if it cannot be, the banner says why and waits.
 */
export function UpdateBanner() {
  const updateWaiting = useOfflineShell((s) => s.updateWaiting);
  const updatedElsewhere = useOfflineShell((s) => s.updatedElsewhere);
  const applying = useOfflineShell((s) => s.applying);
  const problem = useOfflineShell((s) => s.problem);
  const dismissed = useOfflineShell((s) => s.dismissed);
  if ((!updateWaiting && !updatedElsewhere) || dismissed) return null;
  return (
    <div className={styles.banner} role="region" aria-label="App update">
      <RefreshCw className={styles.icon} aria-hidden="true" />
      <div className={styles.text}>
        <p>
          {updatedElsewhere
            ? 'Jamie’s Nails Pro was updated in another tab. Reload this tab to use the new version.'
            : 'A new version of Jamie’s Nails Pro is ready. Your work is saved before it updates.'}
        </p>
        {problem ? (
          <p className={styles.problem} role="alert">
            {problem}
          </p>
        ) : null}
      </div>
      <div className={styles.actions}>
        <Button size="sm" variant="primary" disabled={applying} onClick={() => void applyUpdate()}>
          {applying ? 'Saving and updating…' : updatedElsewhere ? 'Reload now' : 'Update now'}
        </Button>
        <Button size="sm" variant="ghost" disabled={applying} onClick={dismissUpdate}>
          Later
        </Button>
      </div>
    </div>
  );
}
